import { COUNTRY_CODES } from 'swag-common/constants/shipping.constants';
export function isInternationalOrder(order) {
  return !order.deliverToFulfillmentCenter && order.country !== COUNTRY_CODES.US;
}